import {createContext} from 'react';

export const ChartHeightContext = createContext<number | undefined>(undefined);
